window.BUTTabs = window.BUTTabs || class BUTTabs extends BUTCustomComponent {
  constructor() {
    super();
    this.tabLinks = this.$$(".js-tab-link");
    this.tabPanels = this.$$(".js-tab-panel");
    this.tabContent = this.$(".js-tab-content");
    this.isInitialized = false;

    this.handleMutation = this.handleMutation.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);

    this.init();
  }

  init() {
    if (!this.tabLinks.length || !this.tabPanels.length) return;

    this.initMutationObserver();
    this.bindEventHandlers();
    this.initResizeObserver();

    requestAnimationFrame(() => {
      this.activateInitialTab();
      this.isInitialized = true;
    });
  }

  initResizeObserver() {
    window.addEventListener("resize", this.handleMutation.bind(this));
  }

  initMutationObserver() {
    if (!this.tabContent) return;

    this.observer = new MutationObserver(this.handleMutation);
    this.observer.observe(this.tabContent, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  }

  handleMutation() {
    const activePanel = this.$(".tab__panel--active");
    if (!activePanel || this.classList.contains("drawer-wrapper")) return;

    requestAnimationFrame(() => {
      this.tabContent.style.minHeight = `${activePanel.offsetHeight}px`;
    });
  }

  activateInitialTab() {
    const initialTab =
      this.$(".js-tab-item:not(.d-none-important) .js-tab-link.true") ||
      this.tabLinks[0];
    if (initialTab) {
      this.activateTab(initialTab);
      const activePanel = this.$(".tab__panel--active");
      activePanel?.classList.add("tab__panel--initial");
    }
  }

  bindEventHandlers() {
    this.tabLinks.forEach((tab) => {
      tab.addEventListener("click", this.handleTabClick);
    });
  }

  handleTabClick(event) {
    event.preventDefault();
    this.activateTab(event.target.closest(".js-tab-link"));
  }

  activateTab(targetTab) {
    if (!targetTab) return;

    const tabId = targetTab.getAttribute("href")?.replace("#", "");
    if (!tabId) return;

    if (this.isInitialized) {
      this.tabPanels.forEach((panel) => {
        panel.classList.add("tab__panel--transitioning");
      });
    }

    this.tabPanels.forEach((panel) => {
      panel.classList.remove("tab__panel--active", "tab__panel--initial");
    });
    this.tabLinks.forEach((link) => {
      link.classList.remove("tab__link--active");
    });

    const targetPanel = this.$(`[data-tab-content-id=${tabId}]`);
    if (targetPanel) {
      targetPanel.classList.add("tab__panel--active");
      targetTab.classList.add("tab__link--active");
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    window.removeEventListener("resize", this.handleResize);
    this.tabLinks.forEach((tab) => {
      tab.removeEventListener("click", this.handleTabClick);
    });
  }
}

if (!customElements.get("but-tabs")) {
  customElements.define("but-tabs", window.BUTTabs);
}